import type { ReactNode } from 'react';

import { Popover } from '@shared/ui/popover';

import { NOTIFICATION_POPOVER_TEXT } from './notification-popover.text';
import { NotificationPopoverList } from './notification-popover-list.ui';

export interface NotificationPopoverProps {
  children: ReactNode;
  showLoading?: boolean;
  onScrollEnd?(): void;
  /** 위 고정 줄의 "모두읽기"(그 회원의 알림 전부를 읽음으로). 없으면 줄이 없다 */
  onReadAll?(): void;
  canReadAll?: boolean;
}

/**
 * 알림 아이콘 아래에 뜨는 알림 상자(Popover bottom · 꼭지 lg). 열림 상태를 갖지 않는다 —
 * 그릴지 말지는 상위(GlobalHeader 의 notificationPanel 슬롯을 채우는 쪽)가 정한다.
 */
export function NotificationPopover({
  children,
  showLoading,
  onScrollEnd,
  onReadAll,
  canReadAll,
}: NotificationPopoverProps) {
  return (
    <Popover
      inline
      open
      placement="bottom"
      arrow="lg"
      aria-label={NOTIFICATION_POPOVER_TEXT.label}
      content={
        <NotificationPopoverList
          showLoading={showLoading}
          onScrollEnd={onScrollEnd}
          onReadAll={onReadAll}
          canReadAll={canReadAll}
        >
          {children}
        </NotificationPopoverList>
      }
    />
  );
}
